<script lang="ts">
    import { DEFAULT_LAYOUT } from '$lib/components/constants';

    import { cn } from '$lib/utils/cn';

    import Box from '../_wrappers/Box.svelte';

    import type {
        DividerLineStyle,
        DividerSize,
    } from '$lib/types/Components/Divider/DividerContent';
    import type { Box as BoxType } from '$lib/types/Components/SharedTypes';
    import type { TransitionEffect } from '$lib/types/Theme';

    export let box: BoxType;
    export let lineStyle: DividerLineStyle = 'hidden';
    export let color = '#d4d4d8';
    export let transitionDelay = 0;
    export let transitionEffect: TransitionEffect = 'default';
    export let layout = DEFAULT_LAYOUT;
    export let size: DividerSize = 'small';
    export let id: string;

    // Default font-family to Sans Serif as some custom fonts break the page when having special chars as content
    const dividerClasses = cn('fun-select-none fun-border-t fun-font-sans', {
        'fun-border-t-0': lineStyle === 'hidden',
        'fun-border-dashed': lineStyle === 'dashed',
        'fun-border-dotted': lineStyle === 'dotted',
    });

    const wrapperClasses = cn('fun-h-0 fun-select-none', {
        'fun-py-5': size === 'small',
        'fun-py-8': size === 'medium',
        'fun-py-11': size === 'large',
        'fun-py-16': size === 'xLarge',
    });

    const dividerBox: BoxType = layout.isInColumn ? { ...box, left: 'none', right: 'none' } : box;
</script>

<Box {...dividerBox} {transitionDelay} {transitionEffect} {id}>
    <div class={wrapperClasses}>
        <div style="border-color: {color};" class={dividerClasses}>&nbsp;</div>
    </div>
</Box>
